var _g, _path, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 4,
    height: 28,
    rx: 1,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 6,
    width: 4,
    height: 28,
    rx: 1,
    fill: "#814DE5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 18.5858C12.6332 17.8047 11.3668 17.8047 10.5858 18.5858C9.80474 19.3668 9.80474 20.6332 10.5858 21.4142L22.5858 33.4142C23.3429 34.1714 24.5621 34.1979 25.3514 33.4743L37.3514 22.4743C38.1657 21.7279 38.2207 20.4628 37.4743 19.6485C36.7279 18.8343 35.4628 18.7793 34.6486 19.5257L24.0602 29.2317L13.4142 18.5858Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 18.5858C12.6332 17.8047 11.3668 17.8047 10.5858 18.5858C9.80474 19.3668 9.80474 20.6332 10.5858 21.4142L22.5858 33.4142C23.3429 34.1714 24.5621 34.1979 25.3514 33.4743L37.3514 22.4743C38.1657 21.7279 38.2207 20.4628 37.4743 19.6485C36.7279 18.8343 35.4628 18.7793 34.6486 19.5257L24.0602 29.2317L13.4142 18.5858Z",
    fill: "#814DE5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 38,
    width: 36,
    height: 4,
    rx: 1.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 38,
    width: 36,
    height: 4,
    rx: 1.5,
    fill: "#814DE5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.193fda0ce701bd57295f1b3e813a0cf9.svg";
export { ForwardRef as ReactComponent };